import { createAxiosInstance } from "./client";
import { msalInstance } from "./msalInstance";

const axiosInstance = createAxiosInstance(msalInstance);
const ENDPOINT = '/orchestrator';

export async function approveProcurement(uuidProcurement) {
  try {
    const data = {
      uuidProcurement: uuidProcurement,
      action: "approve",
      request: {},
    };
    const response = await axiosInstance.post(`${ENDPOINT}`, data);
    return response.data.procurements;
  } catch (error) {
    console.error(error);
    throw new Error("Erreur lors de l'approbation du marché.");
  }
};

export async function requestProcurement(uuidProcurement, message, type) {
  try {
    const data = {
      uuidProcurement: uuidProcurement,
      action: "request",
      request: {
        type: type,
        data: {
          message: message,
        },
      },
    };
    const response = await axiosInstance.post(`${ENDPOINT}`, data);
    return response.data.procurements;
  } catch (error) {
    console.error(error);
    throw new Error("Erreur lors de la demande d'informations du marché.");
  }
};
